import { render, staticRenderFns } from "./play.vue?vue&type=template&id=a52f7fec&scoped=true"
import script from "./play.vue?vue&type=script&lang=js"
export * from "./play.vue?vue&type=script&lang=js"
import style0 from "./play.vue?vue&type=style&index=0&id=a52f7fec&prod&lang=css"
import style1 from "./play.vue?vue&type=style&index=1&id=a52f7fec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52f7fec",
  null
  
)

export default component.exports